module.exports = __webpack_public_path__ + "static/media/Logo_Blanco.2d63d073.png";